import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { cloneDeep } from 'lodash'
// types

interface IUser {
  refresh?: boolean
  recentlyModifiedUserGuid?: string
  recentlyModifiedUserEmail?: string
}

const userSliceInitialState = {
  refresh: false,
  recentlyModifiedUserGuid: undefined,
  recentlyModifiedUserEmail: undefined,
} as IUser

export const userSlice = createSlice({
  name: 'user',
  initialState: userSliceInitialState,
  reducers: {
    updateCurrentUser(state: IUser, action: PayloadAction<IUser>) {
      state.refresh = cloneDeep(action.payload.refresh)
      if (action.payload.recentlyModifiedUserGuid !== undefined) {
        state.recentlyModifiedUserGuid = action.payload.recentlyModifiedUserGuid
      }
      if (action.payload.recentlyModifiedUserEmail !== undefined) {
        state.recentlyModifiedUserEmail = action.payload.recentlyModifiedUserEmail
      }
    },
  },
})

export const { updateCurrentUser } = userSlice.actions

export const userReducer = userSlice.reducer
